<template>
<div>
<div style="display:flex;">
       <div style="width:75%;min-width:950px;">
       <basic-container style="width:100%;min-width:950px;">
              <div class="header">
                     <div class="header-title">能源概况</div>
                     <div>
                             <el-select 
                             v-model="projectId"
                            @change="changeProject"
                              placeholder="请选择项目">
                                   <el-option
                                        
                                          v-for="item in projectList"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id">
                                               
                                   </el-option>
                            </el-select>
                     </div>
              </div>
              <div class="data-card-box">
                     <div :class="meterType==1?'data-card active':'data-card'" @click="changeMeterType(1)">
                            <el-image 
                                   class="backgroundImg"
                                   :src="electricityBackground" 
                                   fit="cover"
                            >
                            </el-image>
                            <div class="data-card-content">
                                   <div class="card-header">
                                          <div class="card-title">
                                                 <img src="./img/electricity-icon.png" alt="">
                                                 本月用电
                                          </div>
                                          <div> 
                                                 <span style="color:#FFC82F;margin-right:10px;">{{ energyProbably.electricity.thisMonth }}</span>
                                                 <span style="color:#C3C3C3;">kWh</span>
                                          </div>
                                   </div>
                                   <div class="card-footer">
                                          <span class="card-footer-text">上月用电</span>{{ energyProbably.electricity.lastMonth }} kWh
                                   </div>
                            </div>
                     </div>
                     <div :class="meterType==2?'data-card active':'data-card'" @click="changeMeterType(2)">
                            <el-image 
                                   class="backgroundImg"
                                   :src="waterBackground" 
                                   fit="cover"
                            >
                            </el-image>
                             <div class="data-card-content">
                                   <div class="card-header">
                                          <div class="card-title">
                                                 <img src="./img/water-icon.png" alt="">
                                                 本月用水
                                          </div>
                                          <div> 
                                                 <span style="color:#64B0FF;margin-right:10px;">{{ energyProbably.water.thisMonth }}</span>
                                                 <span style="color:#C3C3C3;">T</span>
                                          </div>
                                   </div>
                                   <div class="card-footer">
                                          <span class="card-footer-text">上月用水</span>{{ energyProbably.water.lastMonth }} T
                                   </div>
                            </div>
                     </div>
                     <div :class="meterType==3?'data-card active':'data-card'" @click="changeMeterType(3)">
                            <el-image 
                                   class="backgroundImg"
                                   
                                   :src="gasBackground" 
                                   fit="cover"
                            >
                            </el-image>
                             <div class="data-card-content">
                                   <div class="card-header">
                                          <div class="card-title">
                                                 <img src="./img/gas-icon.png" alt="">
                                                 本月用气
                                          </div>
                                          <div> 
                                                 <span style="color:#FFA14F;margin-right:10px;">{{ energyProbably.gas.thisMonth }}</span>
                                                 <span style="color:#C3C3C3;">m3</span>
                                          </div>
                                   </div>
                                   <div class="card-footer">
                                          <span class="card-footer-text">上月用气</span>{{ energyProbably.gas.lastMonth }} m3
                                   </div>
                            </div>
                     </div>
                     <div :class="meterType==4?'data-card active':'data-card'" @click="changeMeterType(4)">
                            <el-image 
                                   class="backgroundImg"
                                   
                                   :src="hotBackground" 
                                   fit="cover"
                            >
                            </el-image>
                             <div class="data-card-content">
                                   <div class="card-header">
                                          <div class="card-title">
                                                 <img src="./img/hot-icon.png" alt="">
                                                 本月用热
                                          </div>
                                          <div> 
                                                 <span style="color:#FFC82F;margin-right:10px;">{{ energyProbably.hot.thisMonth }}</span>
                                                 <span style="color:#C3C3C3;">GJ</span>
                                          </div>
                                   </div>
                                   <div class="card-footer">
                                          <span class="card-footer-text">上月用热</span>{{ energyProbably.hot.lastMonth }} GJ
                                   </div>
                            </div>
                     </div>
              </div>
              <div class="broken-box">
                     <div class="header">
                            <span style="font-size:20px;font-weight: bold;">
                                   今日用{{meterType==1?'电量':meterType==2?'水量':meterType==3?'气量':meterType==4?'热':''}}
                            </span>
                            <span style="color:#C9C9C9;">
                                   (截止:{{materTypeEnergy.time}})
                            </span>
                            <span style="color:#FFC015;">
                                   {{materTypeEnergy.todayEnergy}} kWh
                            </span>
                            <span style="color:#C9C9C9;">
                                   对比
                            </span>
                            <el-select
                                   v-model="compareType"
                                   style="width:80px;margin-right:20px;"
                                   @change="changeCompareType"
                            >
                                   <el-option
                                          v-for="item in compareTypeList"
                                          :key="item"
                                          :label="item.dictValue"
                                          :value="item.dictKey">
                                   </el-option>
                                   
                            </el-select>
                            <span style="color:#9C9C9C;">
                                   {{materTypeEnergy.contrastEnergy}} kWh
                            </span>
                            <span style="color:#FF5F5F;" v-if="materTypeEnergy.contrastEnergy!=0">
                                   {{
                                          materTypeEnergy.gains>0?'+'+materTypeEnergy.gains+'%':materTypeEnergy.gains==0?materTypeEnergy.gains:materTypeEnergy.gains+'%'
                                   }}
                                   <span class="el-icon-top" v-if="materTypeEnergy.gains>0"></span>
                                   <span class="el-icon-bottom" v-if="materTypeEnergy.gains<0"></span>
                            </span>
                     </div>
                     <div id="main" style="width: 100%;height:400px;"></div>
              </div>
              
       </basic-container>
       <div class="crud-box" style="display:flex;width:100%;min-width:950px;">
               
              <basic-container style="width:45%;">
                    
                            <div class="crud-cellpolice" style="width:100%;">
                                   <div class="title">
                                          <span>
                                                 报警信息
                                                 <span>(所有设备)</span>
                                          </span>
                                          <el-button @click="$router.push('/v4ward/energy/warnings/energywarnings')"  type="text">更多</el-button>
                                         
                                   </div>
                                   
                                   <el-table
                                   ref="filterTable"
                                   height="201"
                                   :data="callPoliceData"
                                   >
                                   
                                   <el-table-column
                                   prop="areaName"
                                   label="区域"
                                   
                                   show-overflow-tooltip
                                   >
                                   </el-table-column>
                                   <el-table-column
                                   prop="meterName"
                                   label="仪表"
                                   align="center"
                                   show-overflow-tooltip
                                   >
                                   </el-table-column>
                                   <el-table-column
                                   prop="meterNo"
                                   width='80'
                                   align="center"
                                   label="仪表编号"
                                   show-overflow-tooltip
                                   filter-placement="bottom-end">
                                   </el-table-column>
                                          <el-table-column
                                                 show-overflow-tooltip
                                                 prop="warningTime"
                                                 label="时间"
                                                 sortable
                                                 width='100'
                                                 column-key="date"
                                                 >
                                          </el-table-column>
                                   </el-table>
                            </div>
                            
                    
              </basic-container>
              <basic-container style="width:55%;margin-top:-10px;">
                     <div class="crud-energyConsumption" style="width:100%;">
                                   <span class="title" style="">科室能耗排名</span>
                                   <el-button :type="deptMeterType == 1 ?'primary':''" size="small" @click="changeDeptMeterType(1)">用 电</el-button>
                                   <el-button :type="deptMeterType == 2 ?'primary':''" size="small" @click="changeDeptMeterType(2)">用 水</el-button>
                                   <el-button :type="deptMeterType == 3 ?'primary':''" size="small" @click="changeDeptMeterType(3)">用 气</el-button>
                                   <el-button :type="deptMeterType == 4 ?'primary':''" size="small" @click="changeDeptMeterType(4)">用 热</el-button>
                                   
                                   <el-table
                                   ref="filterTable"
                                   height="206"
                                   :data="deptEnergyRankingData"
                                   >
                                   
                                   <el-table-column
                                   prop="deptName"
                                   label="科室"
                                   >
                                   </el-table-column>
                                 
                                   <el-table-column
                                   prop="energyConsumptionCurrentMonth"
                                   label="本月用电"
                                   filter-placement="bottom-end">
                            
                                   </el-table-column>
                                          <el-table-column
                                                 prop="lastEndTime"
                                                 label="时间"
                                                 sortable
                                                
                                                 column-key="date"
                                                
                                                 >
                                                 <template slot-scope="scope">
                                                        {{dayjs(scope.row.lastEndTime).format('YYYY/MM/DD')}}
                                                 </template>
                                          </el-table-column>
                                   </el-table>
                            </div>
              </basic-container>
       </div>
       </div>
       <div style="width:25%;" class="aside">
              <basic-container >
                    
                            <div class="header">
                                   <span class="title">在线情况统计</span>
                            </div>
                            <div class="card-box">
                                   <div class="card" style="margin-right:5px;">
                                          <div class="card-title">
                                                 <img src="./img/concentrator.png" alt="">
                                                 <span>集中器</span>
                                          </div>
                                          <div class="card-content">
                                                 <span>上线数/总数</span>
                                                 <span> 
                                                        <span style="color:#409EFF">{{devicesOnlineStatus.concentrator.onlineCount}}</span>
                                                        <span style="color:#333">/{{devicesOnlineStatus.concentrator.totalCount}}</span> 
                                                 </span>
                                          </div>
                                          <div class="card-footer">
                                                 <el-progress 
                                                 :text-inside="true" 
                                                 :stroke-width="20" 
                                               
                                                 :percentage="devicesOnlineStatus.concentrator.percentage"></el-progress>
                                          </div>
                                   </div>
                                    <div class="card"  style="margin-left:5px;">
                                          <div class="card-title">
                                                 <img src="./img/electricity.png" alt="">
                                                 <span>电表</span>
                                          </div>
                                          <div class="card-content">
                                                 <span>上线数/总数</span>
                                                 <span> 
                                                        <span style="color:#409EFF">{{devicesOnlineStatus.electricity.onlineCount}}</span>
                                                        <span style="color:#333">/{{devicesOnlineStatus.electricity.totalCount}}</span> 
                                                 </span>
                                          </div>
                                          <div class="card-footer">
                                                 <el-progress 
                                                 :text-inside="true" 
                                                 :stroke-width="20" 
                                                 :percentage="devicesOnlineStatus.electricity.percentage"></el-progress>
                                          </div>
                                   </div>
                                    <div class="card"  style="margin-right:5px;">
                                          <div class="card-title">
                                                 <img src="./img/water.png" alt="">
                                                 <span>水表</span>
                                          </div>
                                          <div class="card-content">
                                                 <span>上线数/总数</span>
                                                 <span> 
                                                        <span style="color:#409EFF">{{devicesOnlineStatus.water.onlineCount}}</span>
                                                        <span style="color:#333">/{{devicesOnlineStatus.water.totalCount}}</span>
                                                 </span>
                                          </div>
                                          <div class="card-footer">
                                                 <el-progress 
                                                 :text-inside="true" 
                                                 :stroke-width="20" 
                                                 :percentage="devicesOnlineStatus.water.percentage"></el-progress>
                                          </div>
                                   </div>
                                    <div class="card"  style="margin-left:5px;">
                                          <div class="card-title">
                                                 <img src="./img/gas.png" alt="">
                                                 <span>气表</span>
                                          </div>
                                          <div class="card-content">
                                                 <span>上线数/总数</span>
                                                 <span> 
                                                        <span style="color:#409EFF">{{devicesOnlineStatus.gas.onlineCount}}</span>
                                                        <span style="color:#333">/{{devicesOnlineStatus.gas.totalCount}}</span> 
                                                 </span>
                                          </div>
                                          <div class="card-footer">
                                                 <el-progress 
                                                 :text-inside="true" 
                                                 :stroke-width="20" 
                                                 :percentage="devicesOnlineStatus.gas.percentage"></el-progress>
                                          </div>
                                   </div>
                                   
                            </div>

                     
              </basic-container>
              <basic-container style="margin-top:-10px;">
                     
                            <div class="header">
                                  
                                  <span class="title">重点设备能耗图</span>
                                  <el-select v-model="abc" style="width:100px">
                                         <option value=""></option>
                                  </el-select>
                            </div>
                            <div id="columnar" style="width:100%;min-height:600px;"></div>

                     
              </basic-container>

       </div>
      
</div>
       
</div>
</template>
<script>
import img from "./test.png";
import * as echarts from 'echarts';
import electricityBackground from './img/electricity-background.png';
import waterBackground from './img/water-background.png';
import gasBackground from './img/gas-background.png';
import hotBackground from './img/hot-background.png';

import {
       getProjectList,//项目
       projectDailyEnergy,//日能耗统计
       projectMonthEnergy,//月能耗统计
       getDictData,//字典
       projectWarnings,//报警信息
       projectEnergyRank,//科室能耗排序
       projectDeviceStatus//设别在线
}from "@/api/crmedical/energy/index/index.js"

  export default {
    data() {
      return {
             abc:'1',
             meterType:1,
             deptMeterType:1,//获取科室排名时用的
             compareType:'',//对比类型
             compareTypeList:[],//
             img:img,
             electricityBackground:electricityBackground,
             waterBackground:waterBackground,
             hotBackground:hotBackground,
             gasBackground:gasBackground,
             callPoliceData:[],//报警信息前三名
             deptEnergyRankingData:[],//科室能耗排名前三
             devicesOnlineStatus:{//设备在线情况列表 根据不同设备赋值
                     concentrator:{
                            totalCount:0,
                            onlineCount:0,

                     },
                     electricity:{
                            totalCount:0,
                            onlineCount:0,
                     },
                     water:{
                            totalCount:0,
                            onlineCount:0,
                     },
                     gas:{
                            totalCount:0,
                            onlineCount:0,
                     },
                     
             },
              // 今日能耗对比数据
              materTypeEnergy:{
                     materType:1,
                     time:'',
                     todayEnergy:'',
                     contrastEnergy:'',
                     gains:'',
              },
              // 本月以及上月能耗概况
              energyProbably:{
                     electricity:{
                            thisMonth:'',
                            lastMonth:'',
                     },
                     water:{
                            thisMonth:'',
                            lastMonth:'',
                     },
                     gas:{
                            thisMonth:'',
                            lastMonth:'',
                     },
                     hot:{
                            thisMonth:'',
                            lastMonth:'',
                     },
                     
              },
              projectList:[],
              projectId:'',
              // 折现图配置
              lineOption:{
                     color1:'rgba(255, 187, 0, 0.9)',
                     color2:'rgba(255, 187, 0, 0.3)',
                     usedTodayName:'今日',
                     usedCompareName:'昨日'
              },
      }
    },
    created(){
           this.initData();
    },
    methods:{
       //     初始化数据
       async initData(){
              // 获取项目列表
              await getProjectList().then(res=>{
                     this.projectList = res.data;
                     this.projectId = this.projectList[0]?this.projectList[0].id:'';
                     this.getEnergyProbably();
                     this.projectWarnings();
                     this.projectEnergyRank();
                     this.projectDeviceStatus();
              })

              //     获取字典
              await getDictData({code:'compare_date_type'}).then(res=>{
                     this.compareTypeList = res.data;
                     this.compareType = this.compareTypeList[0].dictKey;
                     this.projectDailyEnergy(true);
              })
              
       },
       // 切换对比数据对象
       changeCompareType(val){
              this.compareTypeList.forEach(ele=>{
                     if(ele.dictKey==val){
                            this.lineOption.usedCompareName = ele.dictValue;
                     }
                     this.projectDailyEnergy(true)
              })
       },
       //     切换仪表视角
       changeMeterType(type){
              switch(type){
                     case 1:
                            this.lineOption.color1='rgba(255, 187, 0, 0.9)';
                            this.lineOption.color2='rgba(255, 187, 0, 0.3)';
                            break;
                     case 2:
                            this.lineOption.color1='rgba(64, 158, 255, 0.9)';
                            this.lineOption.color2='rgba(64, 158, 255, 0.3)';
                            break;
                     case 3:
                            this.lineOption.color1='rgba(0, 212, 168, 0.9)';
                            this.lineOption.color2='rgba(0, 212, 168, 0.3)';
                            break;
                     case 4:
                            this.lineOption.color1='rgba(255, 127, 14, 0.9)';
                            this.lineOption.color2='rgba(255, 127, 14, 0.3)';
                            break;
              }
              this.meterType = type;
              this.materTypeEnergy.meterType = type;
              this.projectDailyEnergy(true);

       },
       //     切换项目
       changeProject(projectId){
              this.getEnergyProbably(projectId);
              this.projectDailyEnergy(true);
              this.projectWarnings(projectId);
              this.projectEnergyRank(projectId);
              this.projectDeviceStatus(projectId);

       },
       // 切换科室排名的仪表
       changeDeptMeterType(val){
              this.deptMeterType = val;
              this.projectEnergyRank();
       },
       // 获取今日能耗折线图 以及 对比能耗（通过数据自己算） 
       projectDailyEnergy(queryToday){       
              projectDailyEnergy(
                     {
                            projectId:this.projectId,
                            meterType:this.meterType,
                            queryToday:queryToday,
                            compareType:this.compareType,
                     }
              ).then(({data})=>{
                     this.materTypeEnergy.todayEnergy = data.todayUsed;
                     this.materTypeEnergy.contrastEnergy = data.compareUsed;
                     this.materTypeEnergy.gains =  ((Number(this.materTypeEnergy.todayEnergy) - Number(this.materTypeEnergy.contrastEnergy))/Number(this.materTypeEnergy.contrastEnergy))*100;
                     let thisHour = this.dayjs().hour();
                     if(thisHour%2==0){
                            this.materTypeEnergy.time = thisHour + ':00';
                     }else{
                            this.materTypeEnergy.time = (thisHour-1) + ':00';
                     }
                     
                     let lineCharData = {
                            color1:this.lineOption.color1,
                            color2:this.lineOption.color2,
                            series:{
                                   usedTodayName:this.lineOption.usedTodayName,
                                   usedCompareName:this.lineOption.usedCompareName,
                                   usedToday:[],
                                   usedCompare:[],
                            }
                     };
                     // 处理折线图今日数据
                     let usedToday = data.usedToday;
                     usedToday.forEach(ele => {
                            lineCharData.series.usedToday.push(ele.statisticsNum);
                     });
                     // 处理折线图对比数据
                     let usedCompare = data.usedCompare;
                     usedCompare.forEach(ele => {
                            lineCharData.series.usedCompare.push(ele.statisticsNum);
                     });
                     if(usedToday.length<1){
                            lineCharData.usedToday=[0];
                     }
                     if(usedCompare.length<1){
                            lineCharData.usedCompare = [0];
                     }
                     console.log(lineCharData)
                     // 调用方法渲染折线图
                     this.renderColumnarTodayElectricity(lineCharData);
              })
       },
       
       // 获取能源概况
       async getEnergyProbably(projectId){
              
              await  projectMonthEnergy({projectId:projectId||this.projectId,meterType:1}).then(res=>{
                            this.energyProbably.electricity.thisMonth = res.data.energyConsumptionCurrentMonth;
                            this.energyProbably.electricity.lastMonth = res.data.energyConsumptionLastMonth;
                     })
              await  projectMonthEnergy({projectId:projectId||this.projectId,meterType:2}).then(res=>{
                            this.energyProbably.water.thisMonth = res.data.energyConsumptionCurrentMonth;
                            this.energyProbably.water.lastMonth = res.data.energyConsumptionLastMonth;
                     })
              await  projectMonthEnergy({projectId:projectId||this.projectId,meterType:3}).then(res=>{
                            this.energyProbably.gas.thisMonth = res.data.energyConsumptionCurrentMonth;
                            this.energyProbably.gas.lastMonth = res.data.energyConsumptionLastMonth;
                     })
              await  projectMonthEnergy({projectId:projectId||this.projectId,meterType:4}).then(res=>{
                            this.energyProbably.hot.thisMonth = res.data.energyConsumptionCurrentMonth;
                            this.energyProbably.hot.lastMonth = res.data.energyConsumptionLastMonth;
                     })
              console.log(this.energyProbably)
              this.$forceUpdate();
              
       },
       // 获取报警信息前三位
       projectWarnings(projectId){
              projectWarnings({projectId:projectId||this.projectId}).then(({data})=>{
                     
                     this.callPoliceData = data;
              })
       },
       // 获取科室排名前三名
       projectEnergyRank(projectId){
              projectEnergyRank({projectId:projectId||this.projectId,meterType:this.deptMeterType}).then(({data})=>{
                     this.deptEnergyRankingData = data;
              })
       },
       // 获取设备在线情况
       projectDeviceStatus(projectId){
              projectDeviceStatus({projectId:projectId||this.projectId}).then(({data})=>{
                     data.forEach(ele=>{
                            if(!ele.totalCount || ele.totalCount==0){
                                   ele.percentage = 100;
                            }else{
                                   ele.percentage = parseInt(ele.onlineCount/ele.totalCount*100);
                            }
                            switch(ele.deviceType){
                                   case 1:this.devicesOnlineStatus.electricity=ele;break;
                                   case 2:this.devicesOnlineStatus.water=ele;break;
                                   case 3:this.devicesOnlineStatus.gas=ele;break;
                                   case 9:this.devicesOnlineStatus.concentrator=ele;break;
                            }
                     })
                     this.$forceUpdate();
              })
       },
       // 渲染今日能耗走向图
       renderColumnarTodayElectricity(data){
              console.log(data)
              var chartDom = document.getElementById('main');
              var myChart = echarts.init(chartDom);
              var option;

              option = {
                     
               xAxis: {
                     type: 'category',
                     boundaryGap: false,
                     nameLocation: 'middle',
                     data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00']
              },
              yAxis: {
                     type: 'value',
                     name:'kWh',
                     nameTextStyle:{
                            color:'#C9C9C9'
                     }
              },
              tooltip: {
                     trigger: 'axis'
              },
              series: [
                     {
                            name: data.series.usedTodayName,
                            data: data.series.usedToday,
                            type: 'line',
                            itemStyle : {  
                                normal : {  
                                    color:'#FFBF10',  
                                    lineStyle:{  
                                        color:'#FFBF10'  
                                    }  
                                }  
                            }, 
                            handle: {
                                   show: true,
                                   color: '#FFBF10'
                            },
                            areaStyle: {
                                   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                   offset: 0,
                                   color: data.color1,
                                   }, {
                                   offset: 1,
                                   color: data.color2,
                                   }])
                            },


                     },
                      {
                            name: data.series.usedCompareName,
                            data: data.series.usedCompare,
                            type: 'line',
                            lineStyle:{
                                   color:'#ACACAC'
                            },
                            itemStyle : {  
                                normal : {  
                                    color:'#ACACAC',  
                                    lineStyle:{  
                                        color:'#ACACAC'  
                                    }  
                                }  
                            },
                            

                     }
              ]
              };
              myChart.setOption(option);
       },
           renderColumnar(){
                  var chartDom = document.getElementById('columnar');
                   var myChart = echarts.init(chartDom);
                            var option;

                            option = {
                                   
                            xAxis: {
                                   type: 'category',
                                   boundaryGap: false,
                                   nameLocation: 'middle',
                                   data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00']
                            },
                            yAxis: {
                                   type: 'value',
                                   name:'kWh',
                                   nameTextStyle:{
                                          color:'#C9C9C9'
                                   }
                            },
                            tooltip: {
                                   trigger: 'axis'
                            },
                            series: [
                                   {
                                          name: '今日',
                                          data: [150, 230, 224, 218, 135, 147, 260, 220, 330, 440, 550, 350, 360, 230],
                                          type: 'line',
                                          itemStyle : {  
                                          normal : {  
                                                 color:'#FFBF10',  
                                                 lineStyle:{  
                                                 color:'#FFBF10'  
                                                 }  
                                          }  
                                          }, 
                                          areaStyle: {
                                                 color:'#FFECB6'
                                          },
                                          // encode: {
                                          //        x: 'Year',
                                          //        y: 'Income',
                                          //        itemName: 'Year',
                                          //        tooltip: ['Income'],
                                          // }

                                   },
                                   {
                                          name: '昨日',
                                          data: [140, 230, 204, 208, 145, 157, 230, 220, 360, 460, 560, 360, 360, 260],
                                          type: 'line',
                                          lineStyle:{
                                                 color:'#ACACAC'
                                          },
                                          // encode: {
                                          //        x: 'Year',
                                          //        y: 'Income',
                                          //        itemName: 'Year',
                                          //        tooltip: ['Income'],
                                          // },
                                          itemStyle : {  
                                          normal : {  
                                                 color:'#ACACAC',  
                                                 lineStyle:{  
                                                 color:'#ACACAC'  
                                                 }  
                                          }  
                                          },
                                          

                                   }
                            ]
                            };
                            myChart.setOption(option);
           },
    },
    mounted(){
           this.renderColumnar();
           
    }
  }
</script>
<style lang="scss" scoped>
.aside{
       .header{
              .title{
                     font-size: 20px;
                     font-weight: 600;
                     color: #333;
              }
       }
       .card-box{
              margin-top:20px;
              display: flex;
              justify-content: space-between;
              width: 100%;
              flex-wrap: wrap;
              .card{
                     width: calc(50% - 5px);
                     max-width: 50%;
                     margin-top: 25px;
                     // margin-right: 10px;
                     .card-title{
                            display: flex;
                            span{
                                   font-size: 18px;
                                   color: #333;
                                   font-weight: 600;
                                   margin-left: 10px;
                            }
                     }
                     .card-content{
                            margin-top: 10px;
                            display: flex;
                            justify-content: space-between;
                            font-size: 12px;
                            color: #BFBFBF;
                     }
                     .card-footer{
                            margin-top: 10px;
                     }
              }
              

       }
       
}
.crud-box{
       display:flex;
       width:100%;
       min-width:950px;
       margin-bottom:30px;
       .crud-energyConsumption{
              .title{
                     position:relative;
                     top:4px;
                     font-size:20px;
                     color:#333333;
                     font-weight:600;
                     margin-right:20px;
              }
       }
       .crud-cellpolice{
              width: 40%;
              font-weight: 600;
              .title{
                     display: flex;
                     justify-content:space-between;
                     span{
                            font-size: 20px;
                            font-weight: 600;
                            color: #333;
                            position: relative;
                            top: 4px;
                            span{
                                   top: 0px;
                                   font-size: 14px;
                                   color: #999;
                            }
                     }
              }
       }
}
.ellipsis-styles{
       text-align: center;

       overflow: hidden;

       text-overflow: ellipsis;

       white-space: nowrap;
}
.broken-box{
       margin-top: 20px;
       width: 100%;
       .header{
              margin-top: 20px;
              justify-content: flex-start;
              span{
                     margin-right:20px;
              }
       }

}
.data-card-box{
       margin-top: 30px;
       width: 100%;
       display: flex;
       .data-card{
              position: relative;
              border: 1px solid #eee;
              font-family: '微软雅黑';
              min-width: 230px;
              
              // height: 200px;
              .backgroundImg{
                     // position: absolute;
                     // top: 0;
                     // left: 0;
                     z-index: 0;
                     width: 100%;
              }
              .data-card-content{
                     position: absolute;
                     height: 100%;
                     top: 0;
                     left: 0;
                     z-index: 100;
                     display: flex;
                     flex-direction: column;
                     justify-content:space-between;
                     .card-header{
                            margin-left: 15px;
                            margin-top: 20px;
                            .card-title{
                                   display: flex;
                                   font-weight: bold;
                                   color: #333;
                                   img{
                                          margin-right:10px;
                                          margin-bottom: 10px;
                                   }
                            }
                     }
                     .card-footer{
                            margin-left: 15px;
                            margin-bottom: 20px;
                            .card-footer-text{
                                   color: #C1C1C1;
                                   margin-right: 10px;
                            }
                     }

              }
       }
       .data-card:hover{
              position: relative;
              top: -5;
              cursor: pointer;
       }
       .active{
              border-top: 5px solid #409EFF;
       }
}
.header{
       width: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
       

       
       .header-title{
              font-size: 20px;
              font-weight: bold;
       }
}


</style>

